module.exports = __webpack_public_path__ + "dingbeauty/admin/img/card_icon_jcb.02ebe254.svg";